// OpenPopupButton — shared "Open" action for the chat tool-call cards. Clicking
// it re-triggers opening the relevant popup (a manual fallback for when the
// auto-open on card render missed due to timing). Brand-primary pill, tw-scoped.

import React from "react";

export function OpenPopupButton({ label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="tw-mt-2 tw-inline-flex tw-items-center tw-gap-1 tw-rounded-full tw-bg-[var(--ac-ink)] tw-px-3 tw-py-1.5 tw-text-[12px] tw-font-medium tw-text-[var(--aidea-on-primary)] tw-transition-colors tw-duration-200 tw-cursor-pointer hover:tw-opacity-90 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[var(--aidea-primary)] focus-visible:tw-ring-offset-1"
    >
      {label}
    </button>
  );
}

export default OpenPopupButton;
